/* DentalWipes landing page interactivity */
(function () {
  'use strict';

  var TEAL = 'rgb(42, 181, 181)';

  /* ---------- Scroll reveal (fade/slide-in) ---------- */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
    if (!els.length) return;
    function revealAll() { els.forEach(function (el) { el.classList.add('revealed'); }); }
    if (!('IntersectionObserver' in window)) { revealAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('revealed'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(revealAll, 2500); // safety net: never leave content hidden
  }

  /* ---------- Product image gallery ---------- */
  function initGallery() {
    var main = document.querySelector('[data-dw-main-image]');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-dw-thumb]'));
    if (!main || !thumbs.length) return;

    // Volledige afbeeldingen vooraf inladen, anders blijft het oude beeld
    // hangen terwijl de nieuwe nog binnenkomt.
    var voorgeladen = {};
    function preload(url) {
      if (!url) return Promise.resolve();
      if (voorgeladen[url]) return voorgeladen[url];
      voorgeladen[url] = new Promise(function (res) {
        var im = new Image();
        im.onload = res;
        im.onerror = res;
        im.src = url;
      });
      return voorgeladen[url];
    }
    function fullSrc(i) {
      var img = thumbs[i] && thumbs[i].querySelector('img');
      return img ? (img.getAttribute('data-full') || img.src) : '';
    }

    function activate(idx) {
      idx = (idx + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t, i) {
        var on = i === idx;
        t.style.border = on ? '2px solid ' + TEAL : '2px solid transparent';
        t.style.opacity = on ? '1' : '0.6';
        t.setAttribute('data-dw-active', on ? 'true' : 'false');
      });
      var img = thumbs[idx].querySelector('img');
      if (!img) return;
      var full = fullSrc(idx);
      // buren alvast klaarzetten voor vloeiend doorklikken
      preload(fullSrc((idx + 1) % thumbs.length));
      preload(fullSrc((idx - 1 + thumbs.length) % thumbs.length));
      preload(full).then(function () {
        main.src = full;
        main.alt = img.alt || main.alt;
      });
    }

    // rest op de achtergrond inladen zodra de pagina rustig is
    var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 600); };
    idle(function () { thumbs.forEach(function (_, i) { preload(fullSrc(i)); }); });

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { activate(i); }); });

    // Mark the first thumb active on load so the prev/next arrows have a starting point.
    if (!thumbs.some(function (t) { return t.getAttribute('data-dw-active') === 'true'; })) {
      thumbs[0].setAttribute('data-dw-active', 'true');
    }
    function currentIndex() {
      var cur = thumbs.findIndex(function (t) { return t.getAttribute('data-dw-active') === 'true'; });
      return cur < 0 ? 0 : cur;
    }

    var next = document.querySelector('[data-dw-gallery-next]');
    if (next) next.addEventListener('click', function () { activate(currentIndex() + 1); });

    var prev = document.querySelector('[data-dw-gallery-prev]');
    if (prev) prev.addEventListener('click', function () { activate(currentIndex() - 1); });
  }

  /* ---------- Sale-banner countdown (reset om middernacht) ---------- */
  function initCountdown() {
    var box = document.querySelector('[data-dw2-countdown]');
    if (!box) return;
    var uur = box.querySelector('[data-dw2-cd-h]');
    var min = box.querySelector('[data-dw2-cd-m]');
    var sec = box.querySelector('[data-dw2-cd-s]');
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var nu = new Date();
      var midder = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate() + 1, 0, 0, 0, 0);
      var over = Math.max(0, Math.floor((midder - nu) / 1000));
      if (uur) uur.textContent = pad(Math.floor(over / 3600));
      if (min) min.textContent = pad(Math.floor((over % 3600) / 60));
      if (sec) sec.textContent = pad(over % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- FAQ accordion (single open) ---------- */
  var PLUS = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus" style="color: rgb(107, 114, 128);"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>';
  var MINUS = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minus" style="color: #fff;"><path d="M5 12h14"></path></svg>';

  function initFaq() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-dw-faq]'));
    if (!items.length) return;

    function setState(item, open) {
      var btn = item.querySelector('[data-dw-faq-toggle]');
      var q = item.querySelector('[data-dw-faq-q]');
      var icon = item.querySelector('[data-dw-faq-icon]');
      var ans = item.querySelector('[data-dw-faq-answer]');
      if (open) {
        btn.style.backgroundColor = 'rgb(13, 27, 42)';
        q.style.color = '#fff';
        icon.style.backgroundColor = TEAL;
        icon.innerHTML = MINUS;
        ans.style.display = 'block';
        btn.setAttribute('aria-expanded', 'true');
      } else {
        btn.style.backgroundColor = 'rgb(255, 255, 255)';
        q.style.color = 'rgb(13, 27, 42)';
        icon.style.backgroundColor = 'rgb(243, 244, 246)';
        icon.innerHTML = PLUS;
        ans.style.display = 'none';
        btn.setAttribute('aria-expanded', 'false');
      }
    }

    items.forEach(function (item) {
      var btn = item.querySelector('[data-dw-faq-toggle]');
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        items.forEach(function (other) { setState(other, false); });
        if (!isOpen) setState(item, true);
      });
    });
  }

  /* ---------- Bundle (offer) selection ---------- */
  function initBundles() {
    var radios = Array.prototype.slice.call(document.querySelectorAll('input[name="offer"]'));
    if (!radios.length) return;
    var priceEl = document.querySelector('[data-dw-price]');
    var compareEl = document.querySelector('[data-dw-compare]');
    var saveEl = document.querySelector('[data-dw-save]');
    var stickyPriceEls = Array.prototype.slice.call(document.querySelectorAll('[data-dw-sticky-price]'));
    var stickyCompareEls = Array.prototype.slice.call(document.querySelectorAll('[data-dw-sticky-compare]'));
    function paint() {
      radios.forEach(function (r) {
        var label = r.closest('label');
        if (!label) return;
        if (r.checked) {
          label.style.backgroundColor = 'rgb(240, 250, 250)';
          label.style.border = '2px solid ' + TEAL;
        } else {
          label.style.backgroundColor = 'rgb(255, 255, 255)';
          label.style.border = '2px solid rgb(226, 232, 240)';
        }
      });
      // Sync the price under the title with the selected pack
      var sel = radios.filter(function (r) { return r.checked; })[0];
      if (sel) {
        var p = sel.getAttribute('data-price');
        var c = sel.getAttribute('data-compare');
        var sv = sel.getAttribute('data-save');
        if (priceEl && p) priceEl.textContent = p;
        if (compareEl && c) compareEl.textContent = c;
        if (saveEl && sv) saveEl.textContent = sv;
        // Keep the sticky buy-bar price in sync too
        if (p) stickyPriceEls.forEach(function (el) { el.textContent = p; });
        if (c) stickyCompareEls.forEach(function (el) { el.textContent = c; });
      }
    }
    radios.forEach(function (r) { r.addEventListener('change', paint); });
    paint();
  }

  /* ---------- Sticky buy bar (mobile) — show after hero ---------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-dw-sticky-bar]');
    var hero = document.getElementById('product-info');
    if (!bar || !hero) return;
    function onScroll() {
      var past = hero.getBoundingClientRect().bottom < 0;
      bar.style.transform = past ? 'translateY(0)' : 'translateY(100%)';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Buy now → straight to checkout via cart permalink ---------- */
  function initCart() {
    var btn = document.querySelector('[data-dw-atc]');
    if (!btn) return;
    var originalHTML = btn.innerHTML;
    function resetBtn() {
      btn.style.opacity = '1';
      btn.style.pointerEvents = 'auto';
      btn.innerHTML = originalHTML;
    }
    btn.addEventListener('click', function () {
      var checked = document.querySelector('input[name="offer"]:checked');
      var variantId = (checked && checked.getAttribute('data-variant-id')) || btn.getAttribute('data-default-variant') || '';
      variantId = variantId.trim();
      if (!variantId) { window.location.href = '/cart'; return; }
      btn.style.opacity = '0.7';
      btn.style.pointerEvents = 'none';
      btn.textContent = 'Bezig met afrekenen…';
      // Cart permalink: loads the selected pack and goes straight to checkout
      // (append ?storefront=true to land on the cart page instead).
      var cfg = document.getElementById('product-info');
      var items = [encodeURIComponent(variantId) + ':1'];
      var gifts = (checked && checked.getAttribute('data-gifts')) || '';
      var GIFT_VARIANTS = {
        ear: (cfg && cfg.getAttribute('data-dw2-gift-ear')) || '',
        eye: (cfg && cfg.getAttribute('data-dw2-gift-eye')) || ''
      };
      gifts.split(',').forEach(function (g) {
        if (GIFT_VARIANTS[g]) items.push(GIFT_VARIANTS[g] + ':1');
      });
      // Cart-permalink: legt de regels vast en gaat direct door naar de checkout.
      var url = '/cart/' + items.join(',');
      var code = cfg && cfg.getAttribute('data-dw2-discount');
      if (code) url += '?discount=' + encodeURIComponent(code);
      window.location.href = url;
    });
    // If the visitor returns via browser back/forward (bfcache restore), the
    // button would otherwise stay frozen on "Bezig met afrekenen…" — restore it.
    window.addEventListener('pageshow', resetBtn);
  }

  /* ---------- Buy-box tabs (Voordelen / Gebruik / Ingrediënten) ---------- */
  function initTabs() {
    var btns = Array.prototype.slice.call(document.querySelectorAll('[data-dw-tab]'));
    var panels = Array.prototype.slice.call(document.querySelectorAll('[data-dw-tab-panel]'));
    if (!btns.length) return;
    function activate(key) {
      btns.forEach(function (b) {
        var on = b.getAttribute('data-dw-tab') === key;
        b.style.background = on ? 'rgb(13, 27, 42)' : 'rgb(255, 255, 255)';
        b.style.color = on ? 'rgb(255, 255, 255)' : 'rgb(107, 114, 128)';
      });
      panels.forEach(function (p) { p.style.display = p.getAttribute('data-dw-tab-panel') === key ? '' : 'none'; });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { activate(b.getAttribute('data-dw-tab')); }); });
  }

  /* ---------- Ingredient selector ---------- */
  var INGREDIENTS = [
    { icon: '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"36\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"color:rgb(42,181,181);\"><path d=\"M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z\"/><path d=\"M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12\"/></svg>', name: 'Theepolyfenolen', description: 'Krachtige antioxidanten uit groene thee die tandplak, tandsteen en slechte adem aanpakken bij de bron.', benefits: ['Vermindert tandplak opbouw', 'Bestrijdt bacteriën die slechte adem veroorzaken', 'Ondersteunt gezond tandvlees'] },
    { icon: '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"36\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"color:rgb(42,181,181);\"><path d=\"M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z\"/><path d=\"m9 12 2 2 4-4\"/></svg>', name: 'CPC (Cetylpyridinium Chloride)', description: 'Een bewezen antibacterieel middel dat schadelijke bacteriën doodt en nieuwe tandplakvorming voorkomt.', benefits: ['Doodt 99% van de bekholte bacteriën', 'Voorkomt nieuwe tandplak', 'Klinisch getest en veilig'] },
    { icon: '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"36\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"color:rgb(42,181,181);\"><path d=\"M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z\"/><path d=\"M19.65 15.66A8 8 0 0 1 8.35 4.34\"/><path d=\"m14 10-5.5 5.5\"/><path d=\"M14 17.85V10H6.15\"/></svg>', name: 'Citroenzuur', description: 'Helpt bestaand tandsteen zacht te maken en los te laten, terwijl het een frisse adem ondersteunt.', benefits: ['Breekt tandsteen af', 'Ondersteunt frisse adem', 'Veilig voor dagelijks gebruik'] },
    { icon: '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"36\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"color:rgb(42,181,181);\"><path d=\"M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z\"/></svg>', name: 'Gezuiverd Water', description: 'Puur, gezuiverd water als basis voor een schone en gehydrateerde bek.', benefits: ['Houdt tandvlees gehydrateerd', 'Ondersteunt schone bek', '100% veilig'] }
  ];
  function initIngredients() {
    var btns = Array.prototype.slice.call(document.querySelectorAll('[data-dw-ingredient]'));
    var desktop = document.querySelector('[data-dw-ing-desktop]');
    var mobile = document.querySelector('[data-dw-ing-mobile]');
    if (!btns.length) return;
    function activate(i) {
      var ing = INGREDIENTS[i];
      if (!ing) return;
      btns.forEach(function (b, j) {
        var on = j === i;
        b.style.backgroundColor = on ? 'rgb(13, 27, 42)' : 'rgb(255, 255, 255)';
        b.style.border = on ? '2px solid rgb(42, 181, 181)' : '2px solid rgb(226, 232, 240)';
        var name = b.querySelector('.text-sm.font-bold');
        var desc = b.querySelector('.text-xs');
        if (name) name.style.color = on ? 'rgb(255, 255, 255)' : 'rgb(13, 27, 42)';
        if (desc) desc.style.color = on ? 'rgba(255, 255, 255, 0.6)' : 'rgb(156, 163, 175)';
      });
      if (desktop) {
        var dE = desktop.querySelector('.text-4xl'); if (dE) dE.innerHTML = ing.icon;
        var dN = desktop.querySelector('h3'); if (dN) dN.textContent = ing.name;
        var dD = desktop.querySelector('p'); if (dD) dD.textContent = ing.description;
        var dB = desktop.querySelectorAll('span.text-sm.font-medium');
        Array.prototype.forEach.call(dB, function (s, k) { if (ing.benefits[k] != null) s.textContent = ing.benefits[k]; });
      }
      if (mobile) {
        var mD = mobile.querySelector('p'); if (mD) mD.textContent = ing.description;
        var mB = mobile.querySelectorAll('span.text-xs.font-medium');
        Array.prototype.forEach.call(mB, function (s, k) { if (ing.benefits[k] != null) s.textContent = ing.benefits[k]; });
        if (btns[i].parentNode) btns[i].parentNode.appendChild(mobile);
      }
    }
    btns.forEach(function (b, i) { b.addEventListener('click', function () { activate(i); }); });
  }

  /* ---------- Rotating announcement bar (mobile) ---------- */
  var ANNOUNCE = ['Gratis verzending vanaf €40,-', '4.8/5 door 1.280+ tevreden baasjes', '60 dagen resultaat-of-geld-terug-garantie', 'Gratis cadeaus vanaf 3 potten'];
  function initAnnouncement() {
    var el = document.querySelector('[data-dw-announcement]');
    if (!el) return;
    var i = ANNOUNCE.indexOf(el.textContent.trim());
    if (i < 0) i = 0;
    setInterval(function () {
      el.style.opacity = '0';
      el.style.transform = 'translateY(8px)';
      setTimeout(function () {
        i = (i + 1) % ANNOUNCE.length;
        el.textContent = ANNOUNCE[i];
        el.style.opacity = '1';
        el.style.transform = 'translateY(0px)';
      }, 300);
    }, 3000);
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- Gift unlock panel ---------- */
  function initGifts() {
    var box = document.querySelector('[data-dw2-giftbox]');
    if (!box) return;
    var GROEN = 'rgb(22, 163, 74)';
    var GROEN_BG = 'rgb(240, 253, 244)';
    var VALUES = { ship: 2.95, ear: 28.95, eye: 26.95 };
    var UNLOCK = { '0': [], '1': ['ship', 'ear'], '2': ['ship', 'ear', 'eye'] };
    var cards = Array.prototype.slice.call(box.querySelectorAll('[data-dw2-gift]'));
    var stops = Array.prototype.slice.call(box.querySelectorAll('[data-dw2-stop]'));
    var bar = box.querySelector('[data-dw2-gift-bar]');
    var count = box.querySelector('[data-dw2-gift-count]');
    var total = box.querySelector('[data-dw2-gift-total]');
    var word = box.querySelector('[data-dw2-gift-word]');
    var LOCK = '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:-1px;"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>';
    var CHECK = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:-1px;"><path d="M20 6 9 17l-5-5"/></svg>';
    function update() {
      var checked = document.querySelector('input[name="offer"]:checked');
      var bundle = checked ? checked.getAttribute('data-bundle') : '0';
      var open = UNLOCK[bundle] || [];
      var som = 0;
      cards.forEach(function (card) {
        var key = card.getAttribute('data-dw2-gift');
        var on = open.indexOf(key) > -1;
        var badge = card.querySelector('[data-dw2-gift-badge]');
        var state = card.querySelector('[data-dw2-gift-state]');
        var img = card.querySelector('img');
        var media = card.querySelector('[data-dw2-gift-media] svg');
        if (on) som += VALUES[key];
        card.style.border = on ? '2px solid ' + GROEN : '2px solid rgb(226, 232, 240)';
        card.style.background = on ? GROEN_BG : 'rgb(243, 244, 246)';
        if (badge) { badge.style.background = on ? GROEN : 'rgb(13, 27, 42)'; }
        if (state) {
          state.innerHTML = on ? CHECK + ' Ontgrendeld' : LOCK + ' ' + (card.getAttribute('data-unlock-label') || '');
          state.style.color = on ? GROEN : 'rgb(148, 163, 184)';
        }
        var lockIcon = card.querySelector('[data-dw2-lockicon]');
        var reveal = card.querySelector('[data-dw2-reveal]');
        if (lockIcon) lockIcon.style.display = on ? 'none' : 'inline-flex';
        if (reveal) reveal.style.display = on ? 'inline-flex' : 'none';
        var nameEl = card.querySelector('[data-dw2-gift-name]');
        if (nameEl) nameEl.textContent = on ? nameEl.getAttribute('data-real-name') : 'Cadeau ' + (cards.indexOf(card) + 1);
        if (media) { media.style.color = on ? GROEN : 'rgb(148, 163, 184)'; }
      });
      stops.forEach(function (s) {
        var on = parseInt(s.getAttribute('data-dw2-stop'), 10) <= parseInt(bundle, 10);
        s.style.background = on ? GROEN : 'rgb(226, 232, 240)';
        s.style.color = on ? '#fff' : 'rgb(71, 85, 105)';
      });
      if (bar) bar.style.width = bundle === '2' ? '100%' : bundle === '1' ? '50%' : '0%';
      if (count) {
        count.textContent = open.length + '/3 cadeaus';
        count.style.color = open.length ? GROEN : 'rgb(148, 163, 184)';
      }
      if (total) total.textContent = '€' + som.toFixed(2).replace('.', ',');
      if (word) {
        word.textContent = open.length ? 'GRATIS ERBIJ' : 'VERGRENDELD';
        word.style.color = open.length ? GROEN : 'rgb(148, 163, 184)';
      }
    }
    var GIFTICON = '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:-1.5px;"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg>';
    var teasers = Array.prototype.slice.call(document.querySelectorAll('[data-dw2-teaser]'));
    function updateTeasers() {
      var checked = document.querySelector('input[name="offer"]:checked');
      var bundle = checked ? parseInt(checked.getAttribute('data-bundle'), 10) : 0;
      teasers.forEach(function (tz) {
        var need = parseInt(tz.getAttribute('data-dw2-teaser'), 10);
        var on = bundle >= need;
        var icon = tz.querySelector('svg');
        var txt = tz.querySelector('[data-dw2-teaser-txt]');
        tz.style.background = on ? 'rgb(220, 252, 231)' : 'rgb(226, 232, 240)';
        tz.style.color = on ? 'rgb(22, 163, 74)' : 'rgb(71, 85, 105)';
        if (icon) icon.outerHTML = on ? GIFTICON : '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:-1.5px;"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>';
        if (txt) txt.textContent = on ? txt.textContent.replace('Ontgrendelt', 'Inbegrepen:').replace('Inbegrepen::', 'Inbegrepen:') : txt.textContent.replace('Inbegrepen:', 'Ontgrendelt');
      });
    }
    Array.prototype.forEach.call(document.querySelectorAll('input[name="offer"]'), function (r) {
      r.addEventListener('change', function () { update(); updateTeasers(); });
    });
    update();
    updateTeasers();
  }

  ready(function () {
    initGifts();
    initCountdown();
    initReveal();
    initGallery();
    initFaq();
    initBundles();
    initStickyBar();
    initCart();
    initTabs();
    initIngredients();
    initAnnouncement();
  });
})();
